<template>
    <v-app class="theme-cc2 vuetify3">
        <v-main class="fill-height" style="padding: 0px;">
            <router-view :key="security?.key"></router-view>
            <error-snackbar />
            <ModalComponent></ModalComponent>
        </v-main>
    </v-app>
</template>

<script>
import ErrorSnackbar from './components/ErrorSnackbar.vue';
import { useSecurity } from './stores/security';
import { applyConnectSettings } from './utils/connectSettings';
import ModalComponent from './components/Modals/ModalComponent.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "App",
    data() {
        return {
            security: undefined
        }
    },
    async mounted() {
        this.security = await useSecurity();

        // security restored from the session storage after a reload of the iframe: Home is not shown
        if (this.security.connect) {
            applyConnectSettings(this.$vuetify, this.security);
        }
    },
    components: {
        ErrorSnackbar,
        ModalComponent,
    },
})
</script>

<style>
@import './theme/theme.css';
@import "@vue-flow/core/dist/style.css";
@import "@vue-flow/core/dist/theme-default.css";
</style>
